<template>
  <div class="c-table" ref="robottable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table
      ref="table"
      class="common-el-table-styles summary-el-table-styles"
      v-loading="loading"
      :data="data"
      :height="height"
      border
      stripe
      show-summary
      :summary-method="getSummaries"
      @sort-change="sortChange"
    >
      <template slot="empty">
        <no-data />
      </template>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'thirtyDayCycleRoi'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'thirtyDayRoi'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { toPercentFixed } from '@/common/js/filters'
export default {
  name: 'robotTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    height: {
      type: Number
    }
  },
  methods: {
    getSummaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.summary))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const rates = ['thirtyDayRoi', 'thirtyDayCycleRoi']
        if (rates.includes(prop)) sums[index] = toPercentFixed(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    }
  }
}
</script>
